import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useSite } from "../../context/SiteContext";

const LeafletMap = lazy(() => import("./LeafletMap"));

export const LunessaMap = () => {
  const { settings } = useSite();
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        setVisible(true);
        io.disconnect();
      }
    }, { rootMargin: "200px" });
    io.observe(ref.current);
    return () => {
      io.disconnect();
    };
  }, []);

  return (
    <div ref={ref} className="relative z-0 h-[340px] w-full bg-cream-dark sm:h-[400px] lg:h-full lg:min-h-[440px]" data-testid="contact-map">
      {visible && (
        <Suspense fallback={null}>
          <LeafletMap lat={Number(settings.map_lat)} lng={Number(settings.map_lng)} />
        </Suspense>
      )}
    </div>
  );
};
